import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import * as constants from 'utils/itineraries/functions';

type Props = {
  landingTheme?: string | null;
  isPortal?: boolean;
  isItinerariesItem?: boolean;
  hasHeader?: boolean;
};

export const useScrollOffset = ({ landingTheme, isPortal, isItinerariesItem, hasHeader }: Props) => {
  const { isTabletOrMobile } = useMediaBreakpoints();

  const baseOffset = (isFirst: boolean) => {
    if (landingTheme === constants.LANDING_THEMES.nomad) {
      const baseHeight = isTabletOrMobile
        ? constants.NOMAD_THEME_MOBILE_HEADER_HEIGHT
        : constants.NOMAD_THEME_HEADER_HEIGHT;
      return -1 * (baseHeight + 1);
    }
    if (landingTheme === constants.LANDING_THEMES.jbd) {
      const baseHeight = isTabletOrMobile
        ? constants.JBD_THEME_MOBILE_HEADER_HEIGHT
        : constants.JBD_THEME_HEADER_HEIGHT;
      return -1 * (baseHeight + 1);
    }
    if (isPortal) return isFirst ? -500 : -220;
    return isFirst ? -500 : -120;
  };

  const clickOffset = (isFirst: boolean) => {
    if (landingTheme === constants.LANDING_THEMES.nomad) {
      const baseHeight = isTabletOrMobile
        ? constants.NOMAD_THEME_MOBILE_HEADER_HEIGHT
        : constants.NOMAD_THEME_HEADER_HEIGHT;
      return -1 * baseHeight;
    }
    if (landingTheme === constants.LANDING_THEMES.jbd) {
      const baseHeight = isTabletOrMobile
        ? constants.JBD_THEME_MOBILE_HEADER_HEIGHT
        : constants.JBD_THEME_HEADER_HEIGHT;
      return -1 * baseHeight;
    }
    if (isItinerariesItem) return isFirst ? -500 : isTabletOrMobile ? -80 : 0;
    if (!hasHeader) return isFirst ? -500 : -30;
    return isFirst ? -500 : -80;
  };

  return { baseOffset, clickOffset };
};
